import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  makeStyles,
  Button,
  Grid,
  Fab,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  DialogTitle,
  Card,
  CardHeader,
  CardContent
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import theme from '../theme';
import useSessionContext from '../sessions/useSessionContext';

const useStyles = makeStyles((theme) => ({
  root: {
    'ul li': {
      display: 'flex',
    },
  },

  shareMenu: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  shareButton: {
    display: 'flex',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
    fontSize: '0!important',
    borderRadius: '50px!important',
    border: 0,
    background: 0,
    '&:focus': {
      boxShadow: '0 0 0 2pt #999',
      outline: 0,
    },
    '&  svg': {
      width: '30px',
      height: '30px',
      borderRadius: '50px',
    },
  },
  error: {
    color: '#e5087e',
    fontFamily: ['Dosis', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    marginTop: '3px',
    fontWeight: '500',
  },
  forgotPasswordBtn: {
    textAlign: 'left',
    backgroundColor: 'red',
    borderColor: 'red',
    color: 'white',
    cursor: 'pointer',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 16,
    boxShadow: 0,
    transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover,&:focus,&:active': {
      color: 'red',
      borderColor: 'red',
    },
  },
  passwordField: {
    borderRadius: 4,
    border: '1px solid #b2b1b1',
    '& input': {
      padding: '18.5px 14px',
    },
    '&.MuiInput-underline:before': {
      content: 'none',
    },
    '&.MuiInput-underline.Mui-error:after': {
      borderBottomColor: theme.palette.secondary.main,
    },
  },
  reverseButtonStyle: {
    color: '#E5087E',
    backgroundColor: '#ffffff',

    '&:hover': {
      backgroundColor: '#E5087E',
      color: '#ffffff',
    },
    '&:focus, &.focus': {
      backgroundColor: '#E5087E',
      color: '#ffffff',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '20px',
    },
  },
}));

export default function FormConfirmAction(props) {
  const classes = useStyles(theme);
  const { deleteUser } = useSessionContext();
  const history = useHistory();

  const [open, setOpen] = React.useState(false);
  const [formErrors, setFormError] = useState({});

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  function navigate(path) {
    history.push(path);
    setOpen(false);
  }

  const handleDelete = (e) => {
    e.preventDefault();

    deleteUser().then((response) => {
      if (response.status) {
        if (response.status === 200) {
          navigate('/accueil');
        }
      }
    });
  };

  return (
    <div className={classes.connexionContainer}>
      <Button className={classes.forgotPasswordBtn} onClick={handleClickOpen}>
        <Typography>Supprimer le compte</Typography>
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <form className={classes.form}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  padding: '10px 0',
                }}
              >
                <Fab
                  color="secondary"
                  aria-label="close"
                  className={classes.closeButton}
                  onClick={handleClose}
                >
                  <CloseIcon />
                </Fab>
              </Grid>
              <Grid item xs={12}>
                <DialogTitle style={{ textAlign: 'center' }}>
                  Désirez-vous supprimer votre compte ?
                </DialogTitle>
              </Grid>
              <DialogActions
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Button
                  className={classes.reverseButtonStyle}
                  color="primary"
                  onClick={handleDelete}
                >
                  Confirmer
                </Button>
                <Button
                  color={theme.palette.primary.main}
                  onClick={() => handleClose()}
                >
                  Annuler
                </Button>
              </DialogActions>
            </Grid>
          </form>
          <div style={{ position: 'relative', top: 20, textAlign: 'center' }}>
            {formErrors.global && (
              <p className={`${classes.error} ${'error'}`}>
                {formErrors.global}
              </p>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
